import { NgModule } from '@angular/core';
import { WorkflowRunnerStepBuilderService, WorkflowRunService } from '@ca/core/services';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MachineLearningService } from 'src/app/core/services/machine-learning.service';
import { MachineLearningEffects } from './machine-learning.effects';
import * as MachineLearningReducer from './machine-learning.reducer';
import { machineLearningFeatureKey } from './machine-learning.state';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(machineLearningFeatureKey, MachineLearningReducer.reducer), EffectsModule.forFeature([MachineLearningEffects])],
    providers: [MachineLearningService, WorkflowRunnerStepBuilderService, WorkflowRunService],
})
export class MachineLearningStoreModule {}
